'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:ProspectCtrl
 * @description
 * # ProspectCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('ProspectCtrl', ['$scope', 'Prospect', 'Pagination', function($scope, Prospect, Pagination) {
    $scope.search = {
      'search': '',
      'by_column': '',
      'filters': {
        'name': 'fa-sort',
        'created_at': 'fa-sort-desc'
      }
    };

    $scope.prospect = {
      list: [],
      pager: {}
    };

    $scope.getPage = function(page) {
      var params = {
        params: {
          page: page,
          per_page: 10,
          search: $scope.search.search,
          by_column: $scope.search.by_column
        }
      };
      Prospect.index(params).then(function(response) {
        $scope.prospect.list = response.data.prospects;
        $scope.prospect.pager = Pagination.GetPager(
          response.data.meta.pagination.total_objects,
          page,
          response.data.meta.pagination.per_page);
      }, function(error) {
        Prospect.error(error);
      });
    };

    $scope.clearSearch = function() {
      $scope.search = {
        'search': '',
        'by_column': '',
        'filters': {
          'created_at': 'fa-sort-desc'
        }
      };
      $scope.getPage(1);
    }

    $scope.pager = {};
    $scope.getPage(1);

    $scope.filter = function(column) {
      var order = '';
      angular.forEach($scope.search.filters, function(value, key) {
        if(column === key) {
          if($scope.search.filters[key] === 'fa-sort-desc') {
            $scope.search.filters[key] = 'fa-sort-asc';
            order = 'ASC';
          } else {
            $scope.search.filters[key] = 'fa-sort-desc';
            order = 'DESC';
          }
        } else {
          $scope.search.filters[key] = 'fa-sort';
        }
      });
      $scope.search.by_column = {
        column: column,
        order: order
      };
      $scope.getPage(1);
    };

    $scope.deleteProspect = function(prospect) {
      var index = $scope.prospect.list.indexOf(prospect);
      Prospect.delete(prospect.id).then(function() {
        $scope.prospect.list.splice(index, 1);
      }, function(error) {
        Prospect.error(error);
      });
    };
  }]);
